import React, { useEffect, useState } from 'react';

import { Tooltip } from 'antd';
import { useClient } from 'src/contexts';

import styles from './PublicationTargetting.module.css';

import GroupsIcon from 'src/assets/groups.png';
import CityIcon from 'src/assets/city.png';
import DistrictIcon from 'src/assets/quartier.png';

export const PublicationTargetting: React.FC<{
  targetDistricts: Array<string>;
  targetTowns: Array<string>;
  targetDepartments: Array<string>;
  diffusions: any;
  isPublic: boolean;
}> = ({
  targetDistricts,
  targetTowns,
  targetDepartments,
  diffusions,
  isPublic,
}) => {
  const { get } = useClient();
  const [group, setGroup] = useState<any>([]);
  const [targetType, setTargetType] = useState<string>();
  const [title, setTitle] = useState('');
  const [isTarget] = useState(
    !!targetDistricts.length ||
      !!targetTowns.length ||
      !!targetDepartments.length ||
      !isPublic
  );

  const setTargetInformations = () => {
    if (isTarget && targetDistricts.length > 0) {
      setTitle('Publiée dans les quartiers suivants:');
      setTargetType('districts');
    } else if (isTarget && targetTowns.length > 0) {
      setTitle('Publiée dans les villes suivante:');
      setTargetType('towns');
    } else if (isTarget && targetDepartments.length > 0) {
      setTitle('Publiée dans les départements suivants:');
      setTargetType('departments');
    } else if (isTarget && diffusions[0]?.space.model_type === 'group') {
      get(`/groups/${diffusions[0]?.space.id}`, (response: any): void => {
        response.data && setGroup(response.data);
        setTitle('Publiée dans le groupe suivant:');
        setTargetType('group');
      });
    } else {
      setTitle('Publiée dans la ville suivante:');
      setTargetType('town');
    }
  };

  const computeTarget = () => {
    if (targetType === 'town')
      return (
        <span className={styles.target}>
          {diffusions && diffusions[0]?.place?.address?.locality}
        </span>
      );

    if (targetType === 'group')
      return <span className={styles.target}>{group.name}</span>;

    if (targetType === 'towns')
      return targetTowns.map((town, index) => (
        <span key={`${index}-town`} className={styles.target}>
          {town}
        </span>
      ));

    if (targetType === 'districts')
      return targetDistricts.map((district, index) => (
        <span key={`${index}-district`} className={styles.target}>
          {district}
        </span>
      ));

    if (targetType === 'departments')
      return targetDepartments.map((department, index) => (
        <span key={`${index}-department`} className={styles.target}>
          {department}
        </span>
      ));
  };

  useEffect(() => {
    setTargetInformations();
    // eslint-disable-next-line
  }, []);

  return (
    <Tooltip
      placement="right"
      color="#fff"
      overlayClassName={styles.tooltip}
      title={
        <>
          <div className={styles.containerTooltip}>
            <p className={styles.containerTitle}>{title}</p>
            <div className={styles.containerTarget}>{computeTarget()}</div>
          </div>
        </>
      }
    >
      {targetType === 'group' ? (
        <img className={styles.targetIcon} src={GroupsIcon} alt="groups" />
      ) : targetType === 'districts' ? (
        <img className={styles.targetIcon} src={DistrictIcon} alt="district" />
      ) : (
        <img className={styles.targetIcon} src={CityIcon} alt="city" />
      )}
    </Tooltip>
  );
};
